<template>
  <v-menu>
    <template #activator="{ isActive, props }">
      <v-btn
        v-bind="props"
        data-cy="user-menu-button">
        <v-avatar
          image="//loremflickr.com/40/40/kitten"
          size="28" />
        {{ authStore.user?.first_name }}
        <icon-loader
          color="white"
          name="trailing-icon"
          :upside-down="isActive" />
      </v-btn>
    </template>

    <v-list dense>
      <v-list-item @click="showAccountView">
        <v-list-item-title>
          {{ $t("components.UserMenu.Profile") }}
        </v-list-item-title>
      </v-list-item>
      <v-list-item @click="authStore.logout()">
        <v-list-item-title>
          {{ $t("components.UserMenu.Logout") }}
        </v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="
          authStore.superUser.includes(authStore.user.email) &&
          mainStore.activeSpaceId
        "
        @click="setDefaultData">
        <v-list-item-title> Default setzen </v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="mainStore.activeSpaceId"
        @click="listBackups"
        data-cy="list-backups">
        <v-list-item-title>
          {{ $t("Backups verwalten") }}
        </v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="mainStore.activeSpaceId"
        @click="mainStore.leaveSpace()">
        <v-list-item-title>
          <!-- {{ $t("components.UserMenu.Profile") }} -->
          Hauptmenü
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>

  <v-dialog
    v-model="isActive"
    opacity="0.6"
    scrollable
    width="90%">
    <component
      :is="dialogComponent"
      @close="isActive = false" />
  </v-dialog>
</template>

<script setup>
import axios from "axios";
import IconLoader from "../tools/IconLoader.vue";
import { onMounted, ref } from "vue";
import DeleteWithConfirmationButton from "../tools/DeleteWithConfirmationButton.vue";
import { useAuthStore } from "@/stores/authStore";
import { useSpaceStore } from "../../stores/spaceStore";
import BackupList from "../dialogs/BackupList.vue";
import AccountView from "../dialogs/AccountView.vue";
import { useMainStore } from "@/stores/mainStore";

const mainStore = useMainStore();
const authStore = useAuthStore();
const spaceStore = useSpaceStore();

const first_name = ref("");
const last_name = ref("");

onMounted(() => {
  first_name.value = authStore.user.first_name;
  last_name.value = authStore.user.last_name;
  if (!first_name.value && !last_name.value) {
    showAccountView();
  }
});

const isActive = ref(false);
const dialogComponent = ref(null);

const setDefaultData = () => {
  if (authStore.superUser.includes(authStore.user.email)) {
    spaceStore.setDefault();
  }
};

function listBackups() {
  dialogComponent.value = BackupList;
  isActive.value = true;
}

function showAccountView() {
  dialogComponent.value = AccountView;
  isActive.value = true;
}
</script>

<style scoped>
.v-avatar {
  margin-right: 10px;
}
</style>
